import React from "react";

const GuideAgeFormGroup = (props) => {

    return (    
        <div className="form-group">
            <label>Age</label>
            <select name="age-group" value={props.age} onChange={(e) => props.setAge(e.target.value)}>
                <option value="">Select your age group</option>
                <option value="under_18">Under 18</option>
                <option value="18-25">18-25</option>
                <option value="26-35">26-35</option>
                <option value="36-50">36-50</option>
                <option value="50-65">50-65</option>
                <option value="over_65">65+</option>
            </select>
        </div>
        )
}

export default GuideAgeFormGroup;